import React from 'react';
import { Card, CardTitle, BarRow, Grid, MetricCard, Insight } from '../components/UI';
import { useSavedStats } from '../hooks/useAnalytics';

const F = 'system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif';
function fmt(n) { return n === null ? '…' : n.toLocaleString(); }
function pct(a, b) { return b ? Math.round((a / b) * 100) : 0; }

function Skel({ h = 12, mb = 10 }) {
  return (
    <div style={{ height: h, borderRadius: 6, marginBottom: mb,
      background: 'linear-gradient(90deg,#edf2f5 25%,#f5f7f9 50%,#edf2f5 75%)',
      backgroundSize: '200% 100%', animation: 'shimmer 1.6s ease infinite' }} />
  );
}

export default function Saved() {
  const { data, loading } = useSavedStats();

  const maxLoc = (data?.topLocations || [])[0]?.count || 1;

  return (
    <div style={{ fontFamily: F }}>
      <style>{'@keyframes shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}'}</style>

      <Grid cols={3}>
        <MetricCard label="Total saves"      value={loading ? '…' : fmt(data?.total || 0)}
          trend={data?.total > 0 ? 'up' : null} accent="#314F5C" />
        <MetricCard label="Users saving"     value={loading ? '…' : fmt(data?.uniqueUsers || 0)}
          sub="unique user IDs" accent="#6F8FA7" />
        <MetricCard label="Unique locations" value={loading ? '…' : fmt(data?.uniqueLocations || 0)}
          sub="distinct locations saved" accent="#819D84" />
      </Grid>

      <Grid cols={2} mb={0}>
        <Card style={{ marginBottom: 0 }}>
          <CardTitle>Most saved locations</CardTitle>
          {loading ? [1,2,3,4,5].map(i => <Skel key={i} mb={9} />) : (
            data?.topLocations?.length === 0
              ? <Insight type="info">No saves yet. Users can save locations from the main app.</Insight>
              : data.topLocations.map(({ id, name, count }) => (
                  <BarRow key={id} label={name || `Location ${id}`} value={fmt(count)}
                    pct={pct(count, maxLoc)} labelWidth={160} />
                ))
          )}
        </Card>

        <Card style={{ marginBottom: 0 }}>
          <CardTitle>Summary</CardTitle>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {[
              { label: 'Total saves',        value: loading ? '…' : fmt(data?.total || 0) },
              { label: 'Unique users',        value: loading ? '…' : fmt(data?.uniqueUsers || 0) },
              { label: 'Unique locations',    value: loading ? '…' : fmt(data?.uniqueLocations || 0) },
              { label: 'Avg saves per user',  value: loading || !data?.uniqueUsers ? '…'
                : (data.total / data.uniqueUsers).toFixed(1) },
            ].map(({ label, value }) => (
              <div key={label} style={{ display: 'flex', justifyContent: 'space-between',
                alignItems: 'center', padding: '10px 0', borderBottom: '.5px solid rgba(49,79,92,.05)' }}>
                <span style={{ fontSize: '.73rem', color: '#4a6878' }}>{label}</span>
                <span style={{ fontSize: '.73rem', fontWeight: 600, color: '#0f1e28' }}>{value}</span>
              </div>
            ))}
          </div>
        </Card>
      </Grid>
    </div>
  );
}
